<div class="job-posts placements agreements margin-top-13px top-link">
  <div class="card my-profile-form skillassest-form">
    <div class="card-body padding-top padding-left-0px padding-right-0px margin-left-0px padding-bottom-0px">
      <!--<div class="row margin-left-0px margin-right-0px">
    <div class="col-lg-12 col-md-12 col-12 col-sm-12 col-xl-12 padding-left-0px padding-right-0px ">
      <canvas *ngIf="!isRequesting" id="barChart_{{ReportType}}" class="height-210px width-100pe" hidden></canvas>

    </div>





  </div>-->
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">BranchWise Revenue</h4>
            </div>
            <div class="col-md-6 text-align-right">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                  Old Reg No
                </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                  Prime Relation
                </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseRevenueController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">Branchwise Registrations</h4>
            </div>
            <div class="col-md-6 text-align-right">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                  Old Reg No
                </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                  Prime Relation
                </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseRegistrationsController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">BranchWise Refunds</h4>
            </div>
            <div class="col-md-6 text-align-right">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                  Old Reg No
                </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                  Prime Relation
                </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseRefundsController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">Branchwise VendorInvoice</h4>
            </div>
            <div class="col-md-6 text-align-right">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                Old Reg No
              </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                Prime Relation
              </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseVendorInvoiceController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1 | number:'1.2-2' |removeComma}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2 | number:'1.2-2'|removeComma}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4 | number:'1.2-2'|removeComma}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO | number:'1.2-2'|removeComma }}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">Branchwise Dues</h4>
            </div>
            <div class="col-md-6 text-align-right">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                  Old Reg No
                </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                  Prime Relation
                </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseDuesController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>


    </div>


  </div>


</div>

<div class="job-posts placements agreements margin-top-13px top-link2">
  <div class="card my-profile-form skillassest-form">
    <div class="card-body padding-top padding-left-0px padding-right-0px margin-left-0px padding-bottom-0px">
      <!--<div class="row margin-left-0px margin-right-0px">
        <div class="col-lg-12 col-md-12 col-12 col-sm-12 col-xl-12 padding-left-0px padding-right-0px ">
          <canvas *ngIf="!isRequesting" id="barChart_{{ReportType}}" class="height-210px width-100pe" hidden></canvas>

        </div>





      </div>-->
      <div class="row margin-top-5px">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-6 col-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">BranchWise Revenue</h4>
            </div>
            <div class="col-md-6 col-5 text-align-right-small padding-right-0px">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>
          
              <div class="table-component">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero width-auto">
                    <thead class="">
                      <tr>

                        <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                          Year
                        </th>
                        <!--<th class="text-align-center">Day</th>-->
                        <!--<th class="text-align-center">
              Old Reg No
            </th>-->
                        <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                          Month
                        </th>
                        <!--<th class="text-align-center">Start Time</th>-->
                        <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                          GG1
                        </th>

                        <!--<th class="">
              Prime Relation
            </th>-->

                        <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                          GG2
                        </th>
                        <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                          GG4
                        </th>
                        <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                      </tr>
                    </thead>

                    <tbody class="table-body">

                      <tr *ngFor="let p of CurrentBranchWiseRevenueController">

                        <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                        <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                        <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                        <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                        <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                        <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                        <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                      </tr>
                    </tbody>

                  </table>

                </div>
              </div>
           
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-6 col-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">Branchwise Registrations</h4>
            </div>
            <div class="col-md-6  col-5 text-align-right-small padding-right-0px">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>
          
          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                      Old Reg No
                    </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                      Prime Relation
                    </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseRegistrationsController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-6 col-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">BranchWise Refunds</h4>
            </div>
            <div class="col-md-6  col-5 text-align-right-small padding-right-0px">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                      Old Reg No
                    </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                      Prime Relation
                    </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseRefundsController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-6 col-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">Branchwise VendorInvoice</h4>
            </div>
            <div class="col-md-6 col-5 text-align-right-small padding-right-0px">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                      Old Reg No
                    </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                      Prime Relation
                    </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseVendorInvoiceController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-12">
          <div class="row">
            <div class="col-md-6 col-6">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-5px">Branchwise Dues</h4>
            </div>
            <div class="col-md-6 col-5 text-align-right-small padding-right-0px">
              <h4 class="margin-left-5px color-Assign font-weight-bold margin-bottom-0px">[Analysis]</h4>
            </div>
          </div>



          <label *ngIf="isRequesting">Please wait, loading data...</label>

          <div class="table-component">
            <div class="table-responsive">


              <table class="table table-striped margin-left-zero width-auto">
                <thead class="">
                  <tr>

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Year
                    </th>
                    <!--<th class="text-align-center">Day</th>-->
                    <!--<th class="text-align-center">
                      Old Reg No
                    </th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      Month
                    </th>
                    <!--<th class="text-align-center">Start Time</th>-->
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG1
                    </th>

                    <!--<th class="">
                      Prime Relation
                    </th>-->

                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG2
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">
                      GG4
                    </th>
                    <th class="padding-top-5px padding-bottom-5px  font-size-13px">GGHO</th>





                  </tr>
                </thead>

                <tbody class="table-body">

                  <tr *ngFor="let p of CurrentBranchWiseDuesController">

                    <!--<td class="padding-top-0px padding-bottom-0px"> {{p.Month}}</td>-->
                    <td class="padding-top-0px padding-bottom-0px">{{p.year}}</td>

                    <td class="padding-top-0px padding-bottom-0px">{{p.MonthName}}</td>



                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG1}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right"> {{p.GG2}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GG4}}</td>

                    <td class="padding-top-0px padding-bottom-0px text-align-right">{{p.GGHO}}</td>


                  </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
      </div>


    </div>


  </div>


</div>
